// src/services/api.js
import axios from "axios";

// export const baseUrl = process.env.REACT_APP_API_BASE_URL; // replace with your base URL
export const baseUrl = "https://api.glapsol.com/api/v1";
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically attach token to every request if available
api.interceptors.request.use(
  (config) => {
    const userDetails = localStorage.getItem("userDetails");
    const idToken = userDetails ? JSON.parse(userDetails).idToken : null;
    console.log("ID Token:", idToken); // Debugging line
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
